import React, { useEffect } from "react";
import Header from "../../components/Header/LandingHeader";
import NewsItem from "../../components/NewsItem/NewsItem";

import s from "./News.module.scss";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useDispatch, useSelector } from "react-redux";
import { getEvents, getNews } from "../../../../redux/LangingPageSlice";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import PageTitle from "../../components/PageTitle/PageTitle";
import BackLink from "../../components/BackLink/BackLink";

const upcomingEvents = [
  {
    title: "1st Regional Forum and Workshop on the Middle Corridor",
    image: "/images/mld.png",
    to: "/news/upcoming-events/moldova",
    created_at: "18 November 2026",
    location: "Chisinau, Moldova",
  },
  {
    title: "2nd Regional Forum and Workshop on the Middle Corridor",
    image: "/images/баку.jpg",
    to: "/news/upcoming-events/baku",
    created_at: "24 November 2026",
    location: "Baku, Azerbaijan",
  },
];

const News = () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const news = useSelector((state) => state.landing.news);

  useEffect(() => {
    dispatch(getNews());
    dispatch(getEvents());
  }, [dispatch]);

  return (
    <div className={s.news_wrapper}>
      {width > 1000 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}
      {width <= 1000 && (
        <div className={s.back_wrapper}>
          <BackLink fallback="/">Back</BackLink>
        </div>
      )}
      <h1
        className={
          width <= 1000 ? `${s.page_title} ${s.with_back}` : s.page_title
        }
      >
        News & Events
      </h1>
      <PageTitle
        className={`${s.h2} ${s.h2_first}`}
        eyebrow="Upcoming events"
      />
      <div className={`${s.news} ${s.news_upcoming}`}>
        {upcomingEvents?.map((news) => (
          <NewsItem key={news.image} news={news} to={news.to} />
        ))}
      </div>
      <PageTitle
        className={`${s.h2} ${s.h2_second}`}
        eyebrow="Concluded events"
      />
      <div className={s.news}>
        {news?.map((news) => (
          <NewsItem key={news.id} news={news} />
        ))}
      </div>
      <LandingFooter />
    </div>
  );
};

export default News;
